import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-FlagPoland-bolan",
  "use": "icon-FlagPoland-bolan-usage",
  "viewBox": "0 0 1541 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1541 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-FlagPoland-bolan\"><defs><style type=\"text/css\"></style></defs><path d=\"M6.313 1017.718h1519.038V7.538H6.313v1010.18z m1521.551 2.513v-3.77 3.77zM0.031 1024V0h1531.602v1022.744H0.031z\" fill=\"#353636\" p-id=\"25170\" /><path d=\"M2.544 0h1525.32v508.859H2.544z\" fill=\"#EEEEF0\" p-id=\"25171\" /><path d=\"M2.544 512.628h1525.32v508.86H2.544z\" fill=\"#D13C4F\" p-id=\"25172\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol